<template>
  <svg
    class="icon"
    :class="{ 'icon--small': small }"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path v-if="!showCloseIcon" :d="path" :class="{ white: white }" />
    <mask
      v-if="showCloseIcon"
      id="a"
      style="masktype: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <path d="M0 0h24v24H0z" />
    </mask>
    <g v-if="showCloseIcon" mask="url(#a)">
      <path :d="path" />
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Icon',
  props: {
    icon: {
      type: String,
      default() {
        return '';
      }
    },
    white: {
      type: Boolean,
      default() {
        return false;
      }
    },
    small: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  computed: {
    path() {
      let pathStr;
      switch (this.icon) {
        case 'search':
          pathStr =
            'm18.9 20.3-5.6-5.6A6.096 6.096 0 0 1 9.5 16c-1.817 0-3.354-.629-4.612-1.887C3.629 12.854 3 11.317 3 9.5c0-1.817.63-3.354 1.888-4.613C6.146 3.629 7.683 3 9.5 3c1.817 0 3.354.629 4.613 1.887C15.371 6.146 16 7.683 16 9.5a6.096 6.096 0 0 1-1.3 3.8l5.625 5.625a.918.918 0 0 1 .275.675c0 .267-.1.5-.3.7a.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275ZM9.5 14c1.25 0 2.313-.437 3.188-1.312S14 10.75 14 9.5c0-1.25-.437-2.313-1.312-3.188S10.75 5 9.5 5c-1.25 0-2.313.437-3.188 1.312S5 8.25 5 9.5c0 1.25.437 2.313 1.312 3.188S8.25 14 9.5 14Z';
          break;
        case 'basket':
          pathStr =
            'M5 21c-.283 0-.541-.087-.775-.262a1.295 1.295 0 0 1-.475-.688L.95 9.95a.641.641 0 0 1 .112-.65c.16-.2.372-.3.638-.3h5.05l4.4-6.55a.942.942 0 0 1 .35-.325.964.964 0 0 1 .95 0c.15.083.267.192.35.325L17.2 9h5.1c.267 0 .48.1.638.3.158.2.196.417.112.65l-2.8 10.1a1.295 1.295 0 0 1-.475.688A1.263 1.263 0 0 1 19 21H5Zm.5-2h13l2.2-8H3.3l2.2 8Zm6.5-2c.55 0 1.021-.196 1.413-.587.392-.392.587-.863.587-1.413s-.195-1.021-.587-1.413A1.928 1.928 0 0 0 12 13c-.55 0-1.02.196-1.412.587A1.927 1.927 0 0 0 10 15c0 .55.196 1.021.588 1.413.392.391.862.587 1.412.587ZM9.175 9H14.8l-2.825-4.2-2.8 4.2Z';
          break;
        case 'lock':
          pathStr =
            'M12 1c1.383 0 2.563.487 3.538 1.462C16.513 3.437 17 4.617 17 6v2h1c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413v10c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 18 22H6c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 4 20V10c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 6 8h1V6c0-1.383.488-2.563 1.463-3.538C9.438 1.487 10.617 1 12 1Zm0 2c-.833 0-1.542.292-2.125.875A2.893 2.893 0 0 0 9 6v2h6V6c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 12 3ZM6 20h12V10H6v10Zm6-7c-.55 0-1.02.196-1.412.587A1.927 1.927 0 0 0 10 15c0 .55.196 1.021.588 1.413.391.391.862.587 1.412.587.55 0 1.021-.196 1.413-.587.391-.392.587-.863.587-1.413s-.196-1.021-.587-1.413A1.928 1.928 0 0 0 12 13Z';
          break;
        case 'menu':
          pathStr =
            'M4 18a.965.965 0 0 1-.712-.288A.965.965 0 0 1 3 17c0-.283.096-.52.288-.712A.965.965 0 0 1 4 16h16c.283 0 .52.096.712.288A.965.965 0 0 1 21 17c0 .283-.096.52-.288.712A.965.965 0 0 1 20 18H4Zm0-5a.965.965 0 0 1-.712-.288A.965.965 0 0 1 3 12c0-.283.096-.521.288-.713A.967.967 0 0 1 4 11h16c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.712A.965.965 0 0 1 20 13H4Zm0-5a.967.967 0 0 1-.712-.287A.968.968 0 0 1 3 7c0-.283.096-.521.288-.713A.967.967 0 0 1 4 6h16c.283 0 .52.096.712.287.192.192.288.43.288.713a.968.968 0 0 1-.288.713A.967.967 0 0 1 20 8H4Z';
          break;
        case 'close':
          pathStr =
            'm12 13.4-4.9 4.9a.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275.948.948 0 0 1-.275-.7c0-.283.091-.517.275-.7l4.9-4.9-4.9-4.9a.948.948 0 0 1-.275-.7c0-.283.091-.517.275-.7a.948.948 0 0 1 .7-.275c.283 0 .516.092.7.275l4.9 4.9 4.9-4.9a.948.948 0 0 1 .7-.275c.283 0 .516.092.7.275a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7L13.4 12l4.9 4.9a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275L12 13.4Z';
          break;
        default:
          return '';
      }

      return pathStr;
    },
    showCloseIcon(): boolean {
      return this.icon === 'close';
    }
  }
});
</script>

<style lang="scss" scoped>
@import 'src/styles/all.scss';
@import 'node_modules/foundation-sites/scss/util/util';

.icon {
  width: rem-calc(24px);
  height: rem-calc(24px);

  &--small {
    width: rem-calc(20px);
    height: rem-calc(20px);
  }
}

@include breakpoint(small only) {
  .icon {
    width: rem-calc(20px);
    height: rem-calc(20px);
  }
}
</style>
